import { colors, font, spacing, themes, zindex } from '@chegg-ui/theme';
import styled, { css } from 'styled-components';
import { getFloatingInputStyles } from '@chegg-ui/input';
var dark = colors.dark,
  white = colors.white,
  errorRed = colors.errorRed;
var family = font.family,
  size = font.size;
var ErrorText = styled.div.withConfig({
  componentId: "sc-xh5dj8-0"
})(["font-family:", ";color:", ";font-size:", ";padding:10px;"], family.aspira, errorRed, size.px14);
var ZipcodeFieldWrapper = styled.div.withConfig({
  componentId: "sc-xh5dj8-1"
})(["text-align:left;position:relative;min-height:75px;padding-bottom:8px;&[data-disabled='true'] label{color:", ";}"], colors.greyLight);
var ShowSelection = styled.div.withConfig({
  componentId: "sc-xh5dj8-2"
})(["text-align:left;font-family:", ";color:", ";margin-top:10px;", ";"], family.aspira, dark, function (_ref) {
  var isShow = _ref.isShow;
  return !isShow && "display: none;\n";
});
var CitySuggestionWrapper = styled.div.withConfig({
  componentId: "sc-xh5dj8-3"
})(["width:100%;box-sizing:border-box;display:flex;flex-direction:column;", ";position:absolute;top:", ";box-shadow:", ";border:", ";border-radius:", ";font-weight:", ";z-index:", ";"], function (_ref2) {
  var isOpen = _ref2.isOpen;
  return !isOpen && "display: none;\n  ";
}, spacing.px64, themes.horizon.boxShadow.elevation400, function (_ref3) {
  var error = _ref3.error;
  return error ? "2px solid ".concat(errorRed) : "1px solid ".concat(colors.grey300);
}, spacing.px8, font.weight.medium, zindex.dropdown);
var CitySuggestionHeading = styled.div.withConfig({
  componentId: "sc-xh5dj8-4"
})(["padding:", " ", ";gap:", ";font-weight:", ";font-size:", ";letter-spacing:1.25px;"], spacing.px8, spacing.px16, spacing.px16, font.weight.bold, font.size.px12);
var CityError = styled(ErrorText).withConfig({
  componentId: "sc-xh5dj8-5"
})(["background:white;border:none;border-radius:", " border-top-width:0;z-index:", ";"], spacing.px8, zindex.layout);

/* istanbul ignore next */
var DropdownOptionsWrapper = styled.ul.withConfig({
  componentId: "sc-xh5dj8-6"
})(["position:relative;font-family:", ";margin:0;width:100%;background-color:", ";box-sizing:border-box;outline:0px;height:auto;list-style-type:none;flex-direction:column;overflow-x:hidden;overflow-y:auto;z-index:1000;padding:", " 0;border:0px;border-radius:", ";max-height:", ";"], family.aspira, white, spacing.px12, spacing.px8, spacing.px144);
var DropdownOptions = styled.li.withConfig({
  componentId: "sc-xh5dj8-7"
})(["cursor:pointer;color:", ";font-size:", ";white-space:nowrap;text-overflow:ellipsis;outline:0px;display:block;height:auto;line-height:2rem;bottom-margin:0rem !important;border:0px !important;line-height:1rem;padding:", " ", " !important;border-bottom:1px solid ", " !important;border-top:1px solid ", " !important;&:hover{background:", ";color:", ";border-bottom:1px solid ", " !important;border-top:1px solid ", " !important;}"], dark, size.px16, spacing.px12, spacing.px16, colors.transparent, colors.transparent, colors.grey050, colors.grey800, colors.grey600, colors.grey600);
var ProgressIndicator = styled.div.withConfig({
  componentId: "sc-xh5dj8-8"
})(["text-align:left;font-family:", ";color:", ";margin-top:10px;", ";"], family.aspira, dark, function (_ref4) {
  var isDisplay = _ref4.isDisplay;
  return !isDisplay && "display: none;\n  ";
});
var ZipcodeInput = styled.input.withConfig({
  componentId: "sc-xh5dj8-9"
})(["", ""], function (props) {
  return css(["", ""], getFloatingInputStyles(props));
});
export { ZipcodeFieldWrapper, DropdownOptionsWrapper, DropdownOptions, ShowSelection, CitySuggestionWrapper, CitySuggestionHeading, CityError, ProgressIndicator, ZipcodeInput };


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/user-address/dist/esm/internal/ZipcodeField/styled.js
// module id = 4516
// module chunks = 11